import { SceneManager } from './core/sceneManager.js';
import { InputController } from './core/input.js';
import { createTownScene } from './scenes/townScene.js';
import { createHouseScene } from './scenes/houseScene.js';
import { createCafeScene } from './scenes/cafeScene.js';
import { createCourtScene } from './scenes/courtScene.js';
import { createRecCenterScene } from './scenes/recCenterScene.js';
import { createComicsScene } from './scenes/comicsScene.js';
import { createDowntownScene } from './scenes/downtownScene.js';
import { createForestScene } from './scenes/forestScene.js';
import { createClothingScene } from './scenes/clothingScene.js';
import { createFurnitureScene } from './scenes/furnitureScene.js';
import { createFarmScene } from './scenes/farmScene.js';
import { createRestaurantScene } from './scenes/restaurantScene.js';
import { createParkScene } from './scenes/parkScene.js';
import { createSheriffScene } from './scenes/sheriffScene.js';
import { createBankScene } from './scenes/bankScene.js';
import { createCouncilScene } from './scenes/councilScene.js';
import { createFortressScene } from './scenes/fortressScene.js';
import { createFortressDungeonScene } from './scenes/fortressDungeonScene.js';
import { createFortressLibraryScene } from './scenes/fortressLibraryScene.js';
import { createFortressThroneScene } from './scenes/fortressThroneScene.js';
import { createFortressCryptScene } from './scenes/fortressCryptScene.js';
import { createGraveyardScene } from './scenes/graveyardScene.js';
import { createInfiniteToasterScene } from './scenes/infiniteToasterScene.js';
import { createMuseumScene } from './scenes/museumScene.js';
import { createUptownScene } from './scenes/uptownScene.js';
import { createDojoScene } from './scenes/dojoScene.js';
import { createCasinoScene } from './scenes/casinoScene.js';
import { createApartmentScene } from './scenes/apartmentScene.js';
import { createGarageScene } from './scenes/garageScene.js';
import { createSpeedwayScene } from './scenes/speedwayScene.js';
import { createGrillScene } from './scenes/grillScene.js';
import { createBeachScene } from './scenes/beachScene.js';
import { createAquariumScene } from './scenes/aquariumScene.js';
import { createBananaVillageScene } from './scenes/bananaVillageScene.js';
import { createSpaceportScene } from './scenes/spaceportScene.js';
import { createMoonTownScene } from './scenes/moonTownScene.js';
import { createMoonCastleScene } from './scenes/moonCastleScene.js';
import { createDeepSpaceScene } from './scenes/deepSpaceScene.js';
import { createCrovianScene } from './scenes/crovianScene.js';
import { C } from './core/palette.js';
import { HUD } from './ui/hud.js';

// Boot: build the manager + input, register every scene, start in the town.
// Real interiors get registered here as they're built, replacing the stubs.
const BUILD = '2026-07-12.14';   // bump to force a fresh asset hash on deploy
console.log(`Toast Town build ${BUILD}`);

function boot(){
  try {
  const canvas = document.getElementById('scene');
  const manager = new SceneManager(canvas);
  manager.input = new InputController(canvas);

  manager.register('town', createTownScene);

  manager.register('house', createHouseScene());

  // Gary's Comics — comic shop + comic-sorting minigame (real scene).
  manager.register('comics', createComicsScene());

  // Yogurt Café — live rhythm game with the Dancing Fruit Yogurt (real scene).
  manager.register('cafe', createCafeScene());

  // Avocado Court — outdoor basketball minigame + the Rec Center interior.
  manager.register('court', createCourtScene());
  manager.register('reccenter', createRecCenterScene());

  // Downtown district — a second area off the plaza with three storefronts.
  manager.register('downtown', createDowntownScene());
  manager.register('forest', createForestScene());
  manager.register('clothing', createClothingScene());
  manager.register('furniture', createFurnitureScene());
  manager.register('farm', createFarmScene());
  manager.register('restaurant', createRestaurantScene());   // Order Rush lives here
manager.register('park', createParkScene());               // flower & tree planting north of town
manager.register('sheriff', createSheriffScene());         // sheriff station interior + deputy quest
manager.register('bank', createBankScene());               // bread bank savings account
manager.register('council', createCouncilScene());         // city council chambers
manager.register('fortress', createFortressScene());       // ancient fortress interior
manager.register('fortressDungeon', createFortressDungeonScene()); // deeper dungeon crawl
manager.register('fortressLibrary', createFortressLibraryScene()); // crust archives card game
manager.register('fortressThrone', createFortressThroneScene());   // baker king's chamber
manager.register('fortressCrypt', createFortressCryptScene());     // harder skeleton dungeon
manager.register('graveyard', createGraveyardScene());             // forest graveyard + ghost quest
manager.register('infiniteToaster', createInfiniteToasterScene()); // roguelike dungeon
manager.register('museum', createMuseumScene());           // Toast Town Museum (Downtown)
manager.register('uptown', createUptownScene());           // uptown district hub
manager.register('dojo', createDojoScene());               // Rice Boi's board-break dojo
manager.register('casino', createCasinoScene());           // slots + memory card games
manager.register('apartment', createApartmentScene());     // player apartment + furniture
manager.register('garage', createGarageScene());           // car dealership
manager.register('speedway', createSpeedwayScene());       // top-down racer reached through garage
manager.register('grill', createGrillScene());             // big t's grill + flip minigame
manager.register('beach', createBeachScene());             // sandy toes beach + fishing
manager.register('aquarium', createAquariumScene());       // toast town aquarium
manager.register('bananaVillage', createBananaVillageScene()); // banana village
manager.register('spaceport', createSpaceportScene());     // Earth launch pad + fix-the-ship
manager.register('moonTown', createMoonTownScene());       // lunar bubble-dome town
manager.register('moonCastle', createMoonCastleScene());   // Moon King + royal kitchen
manager.register('deepSpace', createDeepSpaceScene());     // Gary's repaired ship → asteroid vista
  manager.register('crovian', createCrovianScene());         // Gary's home system — Dog-Pirates + kin → asteroid vista

  HUD.refreshCrumbs();
  HUD.refreshQuests();
  manager.start();

  // Dev-only: `?scene=beach` boots straight into a zone, so a scene can be looked at
  // without playing to it. import.meta.env.DEV is false in the production build, so
  // Vite strips this — a player can never use it to skip a quest gate.
  const devScene = import.meta.env.DEV && new URLSearchParams(location.search).get('scene');
  if (import.meta.env.DEV) window.__manager = manager;
  manager.goTo(devScene || 'town');
  } catch (err) {
    console.error('Toast Town failed to start:', err);
    showBootError(err);
  }
}

// Full-screen, readable failure message so a boot crash (e.g. no WebGL context
// in Firefox) shows something helpful instead of a blank/brown screen.
function showBootError(err){
  const wrap = document.createElement('div');
  Object.assign(wrap.style, { position: 'fixed', inset: '0', display: 'flex',
    alignItems: 'center', justifyContent: 'center', padding: '24px',
    background: '#BEE3EF', zIndex: '300' });
  const box = document.createElement('div');
  Object.assign(box.style, { maxWidth: '560px', background: '#FFF4DF', color: '#6B4A2F',
    border: '3px solid #6B4A2F', borderRadius: '16px', padding: '20px 22px',
    font: '14px/1.5 system-ui, sans-serif', whiteSpace: 'pre-wrap',
    boxShadow: '0 8px 0 rgba(107,74,47,.35)' });
  box.textContent = `⚠️ Toast Town couldn't start.\n\n${(err && (err.stack || err.message)) || err}\n\n`
    + `If you're on Firefox: enable hardware acceleration (Settings → General → Performance, `
    + `uncheck "Use recommended settings", check "Use hardware acceleration"), then reload — or try Chrome.`;
  wrap.appendChild(box);
  document.body.appendChild(wrap);
}

if (document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
